// extracted by mini-css-extract-plugin
export var menuIcon = "_sy-0";
export var menuIconInline = "_sy-1";